import { render, staticRenderFns } from "./RequestPricingAcknowledge.vue?vue&type=template&id=0865d52e&scoped=true&"
import script from "./RequestPricingAcknowledge.vue?vue&type=script&lang=js&"
export * from "./RequestPricingAcknowledge.vue?vue&type=script&lang=js&"
import style0 from "./RequestPricingAcknowledge.vue?vue&type=style&index=0&id=0865d52e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0865d52e",
  null
  
)

export default component.exports